module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/analysis_1@2x-a7fc1b21b6df77a02dd54bea9537e919.png";